<template>
  <div id="bar2" ref="bar"></div>
</template>
<script>
import echarts from "echarts";
import axios from "axios";
var t;
export default {
  data() {
    return {
      myData: [
        ["f费用项目", "过路费", "停车费", "加邮费"],
        ["粤A324", 10, 20, 30],
        ["粤A322", 10, 0, 0],
        ["粤A323", 0, 10, 0],
        ["粤B324", 30,20, 10],
        ["粤B322", 0, 10, 0],
        ["粤B323", 10, 0, 20],
      ],
      searchItem: {
        startTime: 0,
        endTime: 0,
      },
      //http://www.xianning.gov.cn/images/bg-1400.jpg
    };
  },
  methods: {
    reach(v) {
      this.searchItem.startTime = v.start - 86400000;
      this.searchItem.endTime = v.end - 86400000;
      
    },
    getData() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-upf/data/countAlarm",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data;
        this.myData = [["报警类型", "断电报警", "紧急报警", "超速报警"]];
        data = data.sort(function (a, b) {
          return a.date - b.date;
        });
        for (var i = 0; i < data.length; i++) {
          data[i].date = this.utils.time(data[i].date, "mmdd");
          var arr = ["", 0, 0, 0];
          for (let j = 0; j < data[i].alarmList.length; j++) {

            arr[0] = data[i].date;
            var aa = data[i].alarmList[j].alarmTypeName;
            if (aa.indexOf("断电") != -1) {
              arr[1] = data[i].alarmList[j].num;
            } else if (aa.indexOf("紧急") != -1) {
              arr[2] = data[i].alarmList[j].num;
            } else if (aa.indexOf("超速") != -1) {
              arr[3] = data[i].alarmList[j].num;
            }
          }
          this.myData.push(arr);
        }
        //console.log(data);
        //console.log(this.myData);
        this.drawBar("bar2");
      });
    },
    drawBar(id) {
      var that = this;
      
      this.chart = echarts.init(document.getElementById(id), "dark");

      var colors = ["#f83b3b", "#3ebaf7", "#13ca7f", "#8d8d8d"];
      this.option = {
        backgroundColor: "",
        /* title: {
          text: "车辆状况看板"
        }, */
        grid: {
          x: 30,
          y: 40,
          x2: 10,
          y2: 60, //距离下边的距离
        },
        legend: {
          right: 0, //图例组件离右边的距离
          // orient: "vertical", //布局  纵向布局
          orient: "horizontal", //布局  纵向布局
          width: 350, //图行例组件的宽度,默认自适应
          x: "top", //图例显示在右边
          itemWidth: 10, //图例标记的图形宽度
          itemHeight: 10, //图例标记的图形高度
          textStyle: {
            //图例文字的样式
            color: "#dataModal",
            fontSize: 12,
          },
        },
        tooltip: {
          //工具提示
          left: 20,
          formatter: function (val) {
            return (
              val.seriesName + "（" + val.value[val.seriesIndex + 1] + "次）"
            );
          },
        },
        dataset: {
          source: this.myData,
        },
        xAxis: {
          type: "category",
          axisLabel: { rotate: 45, color: "#999" },
          axisLine: {
            lineStyle: {
              color: "#999", //线条颜色
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "#999", //线条颜色
            },
          },
        },
        yAxis: {
          axisLabel: { rotate: 0, color: "#999" },
          axisLine: {
            lineStyle: {
              color: "#999", //线条颜色
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "#999", //线条颜色
            },
          },
        },

        series: [
          //系列[
          {
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: colors[0],
              opacity: 0.3,
            },
          },
          {
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: colors[1],
              opacity: 0.3,
            },
          },
          {
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: colors[2],
              opacity: 0.3,
            },
          },
          //{ type: "bar", color: ["#8d8d8d"] },
        ],
      };
      this.chart.setOption(this.option);

      this.chart.resize();
    },
  },
  //调用
  mounted() {
    setTimeout(() => {
        this.drawBar("bar2");
      }, 200);
  },
};
</script>
<style lang="">
#bar2 {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/kanban/feiyong/paigongzonglan.vue